import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    tableWrapper: {
        border: 'none !important',
        '& .MuiDataGrid-cell': {
            justifyContent: 'flex-start',
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '143%',
            letterSpacing: '0.17px',
        },
        '& .MuiDataGrid-columnHeader': {
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '143%',
            letterSpacing: '0.17px',
            padding: '0px !important',
        },
        '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: '0px 10px !important',
            '& .currentReportingMonth': {
                width: '100em',
                textAlign: 'right',
            },
        },
    },
    cifTextStyle: {
        color: ' rgba(0, 0, 0, 0.60)',
        fontFamily: 'Inter',
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '14px',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    statusMessage: {
        display: 'flex',
        flexDirection: 'column',
        '& span': {
            color: 'rgba(0, 0, 0, 0.60)',
            fontSize: '10px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '14px',
        },
    },
    currentMonthIndicatorHeader: {
        color: ' rgba(0, 0, 0, 0.87))',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.17px',
        borderLeft: '1px solid #ccc',
        borderRight: '1px solid #ccc',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        padding: '24px',
        alignSelf: 'stretch',
        gap: '24px',
        margin: '0',
    },
    paper: {
        maxWidth: theme.spacing(300),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
    },
    fileCopyIcon: {
        color: '#0000008F',
        cursor: 'pointer',
        fontSize: 'medium',
        verticalAlign: 'middle',
    },
    iconPlacement: {
        marginLeft: theme.spacing(1),
    },
    chipStyle: {
        color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
        fontFeatureSettings: '"clig" off, "liga" off',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '0.16px',
        background: 'var(--action-selected, rgba(0, 0, 0, 0.08))',
    },
    hideRightSeparator: {
        padding: '0 !important',
        '& > .MuiDataGrid-columnSeparator': {
            opacity: '0 !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            padding: '0 0 0 10px !important',
        },
        '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: '0 !important',
        },
    },
    textOverflow: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    placeItemCenter: {
        alignItems: 'center !important',
        justifyContent: 'center !important',
    },
    customStatusColumn:{
        alignItems: 'flex-start !important;',
        justifyContent: 'center !important',
        flexDirection: 'column',
        gap : theme.spacing(0.5)
    },
    fillBlackColor: {
        color: '#00000099',
    },
    colorBlue: {
        color: 'var(--primary-light)',
        textOverflow: 'ellipsis',
        fontFamily: 'Inter',
        fontSize: '14px !important',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '143%',
        letterSpacing: '0.17px',
    },
    fullWidth: {
        width: '100%',
    },
    p0: {
        padding: 0,
    },
    rootClass: {
        minWidth: '100%',
        borderBottom: '1px solid #0000001F',
        '& .Mui-selected': {
            background: 'transparent !important',
            color: 'var(--primary-light)',
        },
        '& .MuiTab-root': {
            maxWidth: 'fit-content !important',
            minWidth: 'fit-content !important',
            padding: '0px 16px',
        },
    },
    chipStyleBeta: {
        display: 'flex',
        padding: '2px 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '72px',
        background: 'var(--blueGrey-100, #CFD8DC)',
    },
    betaLabelTypography: {
        color: 'var(--blueGrey-600, #546E7A)',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '157 %' /* 21.98px */,
        letterSpacing: '0.1px',
    },
    chipStyleSuccess: {
        borderRadius: '100px',
        width: '41px',
        padding: '4px 16px',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        color: '#1B5E20 ',
        background: '#EDF7ED ',
    },
    unResolvedAccountsChip: {
        borderRadius: '100px',
        width: '41px',
        padding: '4px 16px',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        color: '#C62828',
        background: '#FDEDED',
    },
    tabLabelTypography: {
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.4px',
    },
    bookClosureTabContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'var(--8, 8px)',
    },
    tabLabelColor: {
        color: 'unset !important',
    },
    typographyHeader: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.17px',
    },
    borderLeft: {
        borderLeft: '1px solid #ccc',
    },
    borderRight: {
        borderRight: '1px solid #ccc',
    },
    marginTootlip: {
        marginLeft: '4px',
    },
    colorRed: {
        color: '#D32F2F',
    },
    hideSepratorAndRightBorder: {
        borderRight: '1px solid #ccc',
        '& > .MuiDataGrid-columnSeparator': {
            opacity: '0 !important',
        },
    },
    hideSepratorNoRightBorder: {
        borderRight: 'none',
        '& > .MuiDataGrid-columnSeparator': {
            opacity: '0 !important',
        },
    },
    tabWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
    },
    actionButtonContainer: {
        display: 'flex',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
    },

    // Filters
    filtersWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '20px'
    },
    teamCodeSelect: {
        order: 4,
        marginLeft: 'auto'
    },
    teamCodeSwitch: {
        order: 2
    }
}))
